import React, { Component } from "react";
import WebFont from "webfontloader";
import styled from "styled-components";
import { Normalize } from "styled-normalize";
import 'katex/dist/katex.min.css';

import GlobalStyle from "./globalStyle";


class Layout extends Component {
  componentDidMount() {
    // WebFont.load({
    //   google: {
    //     families: ["Open Sans:300,400,500", "Roboto:300,400,500"]
    //     // families: ["Roboto:300,400,500"]
    //   }
    // });
  }

  render() {
    let { children } = this.props;
    return (
      <div>
        <Normalize />
        <GlobalStyle />
       {children}
      </div>
    );
  }
}

export default Layout;
